import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Layout from "pages/shared/Layout";

import { StoreContext } from "shared/context/store-context";
import { PERMISSION_TYPES } from "@routebot/constants";
import { AuthContext } from "shared/context/auth-context";

import InventoryAttendantItem from "./InventoryAttendantItem";

const InventoryAttendants = () => {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const itemType = "attendant";
  const listName = "inventory_attendants";

  const { attendants, DeleteAttendant, UpdateAttendant, InsertAttendant, vehicles } = useContext(StoreContext);

  const [pageItems, setPageItems] = useState();

  useEffect(() => {
    setPageItems(attendants);
  }, [attendants]);

  const listColumns = [
    {
      field: "name",
      headerName: t("inventoryAttendant.columns.name"),
      width: 300,
    },
    {
      field: "phone",
      headerName: t("inventoryAttendant.columns.phone"),
      width: 150,
    },
    {
      field: "vehicle",
      headerName: t("inventoryAttendant.columns.vehicle"),
      width: 150,
      valueGetter: (params) => vehicles.find((vehicle) => vehicle.attendant === params?.row?.id)?.plate || "-",
    },
    {
      field: "identityNumber",
      headerName: t("inventoryAttendant.columns.identityNumber"),
      width: 150,
    },
    {
      field: "sgkRegistration",
      headerName: t("inventoryAttendant.columns.sgkRegistration"),
      width: 200,
    },
    {
      field: "institution1",
      headerName: t("inventoryAttendant.columns.institution1"),
      width: 200,
    },
    {
      field: "institution2",
      headerName: t("inventoryAttendant.columns.institution2"),
      width: 200,
    },
    {
      field: "institution3",
      headerName: t("inventoryAttendant.columns.institution3"),
      width: 200,
    },
    {
      field: "notes",
      headerName: t("inventoryAttendant.columns.notes"),
      width: 520,
    },
  ];

  const standardHelpItems = [
    t("inventoryAttendant.help.standard1"),
    t("inventoryAttendant.help.standard2"),
    t("inventoryAttendant.help.standard3"),
    t("inventoryAttendant.help.standard4"),
  ];

  const highlightedHelpItems = [
    t("inventoryAttendant.help.highlighted1"),
    t("inventoryAttendant.help.highlighted2"),
    t("inventoryAttendant.help.highlighted3"),
    t("inventoryAttendant.help.highlighted4"),
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      showSelectedYear={false}
      isAlwaysFullScreen={false}
      hideCreateNewItem={!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WRITE_INVENTORY]}
      SelectedItemComponent={InventoryAttendantItem}
      NewItemComponent={InventoryAttendantItem}
      DeleteItem={DeleteAttendant}
      InsertItem={InsertAttendant}
      UpdateItem={UpdateAttendant}
      standardHelpItems={standardHelpItems}
      highlightedHelpItems={highlightedHelpItems}
    />
  );
};

export default InventoryAttendants;
